import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'sidenav-fleet-upgrade-banner',
  imports: [TranslocoModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './fleet-upgrade-banner.component.html',
  styleUrls: ['./fleet-upgrade-banner.component.scss']
})
export class FleetUpgradeBannerComponent {}
